export const initialState = {
    page: 0,
    rowsPerPage: 10
};

const abilityReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case 'SET_PAGE_ABILITY':
            return {
                ...state,
                page: actions.payload
            };
        case 'SET_ROWS_PER_PAGE_ABILITY':
            return {
                ...state,
                rowsPerPage: actions.payload
            };
        default:
            return state;
    }
};

export default abilityReducer;
